






















import { Prop, Component, Vue } from "vue-property-decorator";
import { ProjectMessage } from "@/api/message-api";

const MESSAGE_LENGTH = 3;

@Component({})
export default class ProjectMessageList extends Vue {
  @Prop({ required: true }) project!: ProjectMessage;

  get id() {
    return this.project.projectId;
  }

  get name() {
    return this.project.projectName;
  }

  get head() {
    return this.project.messageList.slice(0, MESSAGE_LENGTH);
  }

  get rest() {
    return this.project.messageList.slice(MESSAGE_LENGTH).length;
  }
}
